angular.module('GlobalHelpersModule').filter "appointmentDatetimeLocal", ($filter) ->
  (datetime) ->
    if datetime? and datetime.length > 0 
      shortDay = $filter('dayOfTheWeekLocal')(datetime)
      shortDateLocal = $filter('shortDateLocal')(datetime)
      shortTimeLocal = $filter('shortTimeLocal')(datetime)
      datetimeString = shortDay + ', ' + shortDateLocal + ' ' + shortTimeLocal
    else ""